import * as React from 'react';
import { useSelector } from '../../utils/useSelector';
import URLManager from '../../utils/urlManager';

type Props = {
  refId: string;
  title: string;
} & Pick<React.HTMLAttributes<HTMLAnchorElement>, 'onClick'>;

export const ItemLink = ({ refId, title, onClick }: Props) => {
  const selectedViewId = useSelector(s => s?.view?.selected?.props?.refId);
  const { updateUrl } = URLManager.useRouter();
  if (!refId) return null;
  return (
    <a
      className="tree-link"
      href={`?v=${selectedViewId}&id=${refId}`}
      onClick={e => {
        e.preventDefault();
        if (onClick) onClick(e);
        updateUrl({ id: refId });
      }}
    >
      {title || '<Title Not Defined>'}
    </a>
  );
};
